var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header_alert_component"}},[_c('router-link',{staticClass:"header-alert--inside",attrs:{"to":{ 'name': 'TermsUpdate' }}},[_c('p',[_vm._v("In connection with the introduction of the GDPR please make sure that you accept all required consents. Otherwise you will lose access to your account.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bdcd11c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/header/middlebar/HeaderAlertBottom.vue
// module id = vrhb
// module chunks = 0